require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/node_modules/core-js/library/fn/get-iterator.js
// module id = ../../../../core-js/library/fn/get-iterator.js
// module chunks = vendor